import { ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'phoenix-scrollable-title',
  template: `
    <section
      class="inline-block"
      matTooltip="Copy link to clipboard"
      [cdkCopyToClipboard]="currentUrl + value"
    >
      <div class="flex flex-row group cursor-pointer">
        <ng-content></ng-content>
        <span
          class="ml-1 mt-1 material-icons-outlined hidden group-hover:block self-center"
        >
          link
        </span>
      </div>
    </section>
  `,
  styles: [``],
  standalone: false,
})
export class ScrollableTitleComponent implements OnInit, AfterViewInit {
  @Input() value!: string;
  currentUrl!: string;

  readonly scroller = inject(ViewportScroller);
  readonly route = inject(ActivatedRoute);

  ngOnInit() {
    const url = window.location.origin;
    const route = window.location.pathname;

    this.currentUrl = `${url}${route}#`;
  }

  public ngAfterViewInit(): void {
    this.route.fragment.subscribe(fragment => {
      if (fragment && fragment === this.value) {
        setTimeout(() => {
          this.scroller.scrollToAnchor(fragment);
        });
      }
    });
  }
}
